import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const DollarIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M11.1109 4.66659C10.9097 4.31744 10.6172 4.0296 10.2649 3.83388C9.91263 3.63815 9.51374 3.54192 9.11095 3.55548H6.88873C6.29936 3.55548 5.73413 3.78961 5.31738 4.20636C4.90063 4.6231 4.6665 5.18833 4.6665 5.7777C4.6665 6.36707 4.90063 6.9323 5.31738 7.34905C5.73413 7.7658 6.29936 7.99992 6.88873 7.99992H9.11095C9.70032 7.99992 10.2655 8.23405 10.6823 8.6508C11.099 9.06754 11.3332 9.63277 11.3332 10.2221C11.3332 10.8115 11.099 11.3767 10.6823 11.7935C10.2655 12.2102 9.70032 12.4444 9.11095 12.4444H6.88873C6.48594 12.4579 6.08705 12.3617 5.73475 12.166C5.38245 11.9702 5.09001 11.6824 4.88873 11.3333M7.99984 2.44434V13.5554"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Center>
  );
};
